// 动漫网作品数据：动画库与漫画
export interface Work {
  id: string;
  title: string;
  titleEn: string;
  type: 'anime' | 'manga';
  categories: string[];
  tags: string[];
  year: number;
  status: 'airing' | 'finished' | 'not_start';
  episodes: string;
  rating: number;
  cover: string;
  description: string;
  studio: string;
  isNew?: boolean;
  isHot?: boolean;
}

export const animeWorks: Work[] = [
  {
    id: 'frieren',
    title: '葬送的芙莉莲',
    titleEn: 'Frieren: Beyond Journey\'s End',
    type: 'anime',
    categories: ['fantasy', 'healing', 'new', 'ri'],
    tags: ['奇幻', '治愈', '新番'],
    year: 2023,
    status: 'finished',
    episodes: '全 28 话',
    rating: 9.6,
    isNew: true,
    isHot: true,
    studio: 'MADHOUSE',
    description: '勇者一行打倒魔王后，精灵魔法使芙莉莲在漫长岁月中重新踏上旅程，回顾与同伴相处的点滴，探寻生命的真谛与羁绊的延续。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20silver%20haired%20elf%20mage%20girl%20in%20a%20flowing%20white%20robe%20with%20gentle%20expression%2C%20soft%20glowing%20magic%20orbs%20around%20her%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20simple%20warm%20off%20white%20background%20with%20soft%20gradient%2C%20high%20detail%20anime%20key%20visual%2C%20dreamy%20tranquil%20atmosphere&width=600&height=900&seq=poster-frieren&orientation=portrait',
  },
  {
    id: 'attack-on-titan',
    title: '进击的巨人',
    titleEn: 'Attack on Titan',
    type: 'anime',
    categories: ['shonen', 'fantasy', 'ri'],
    tags: ['热血', '奇幻', '巨人'],
    year: 2013,
    status: 'finished',
    episodes: '全 87 话',
    rating: 9.5,
    isHot: true,
    studio: 'WIT STUDIO',
    description: '人类在巨人的威胁下退守高墙之内，少年艾伦·耶格尔为夺回自由投身调查兵团，揭开世界的残酷真相与自由的真义。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20determined%20dark%20haired%20soldier%20with%20green%20cloak%20facing%20a%20giant%20menacing%20titan%20silhouette%20behind%20high%20walls%2C%20warm%20coral%20and%20teal%20palette%2C%20dramatic%20dusty%20sky%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20epic%20tension&width=600&height=900&seq=poster-attack-on-titan&orientation=portrait',
  },
  {
    id: 'demon-slayer',
    title: '鬼灭之刃',
    titleEn: 'Demon Slayer',
    type: 'anime',
    categories: ['shonen', 'fantasy', 'ri'],
    tags: ['热血', '鬼灭', '剑士'],
    year: 2019,
    status: 'airing',
    episodes: '全 26 话',
    rating: 9.4,
    isHot: true,
    studio: 'ufotable',
    description: '少年炭治郎为拯救变成鬼的妹妹祢豆子，加入鬼杀队踏上斩鬼之旅，在战斗与羁绊中不断成长，追寻让妹妹变回人类的方法。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20young%20swordsman%20with%20checkered%20haori%20and%20scar%20on%20forehead%20holding%20a%20black%20katana%2C%20bamboo%20muzzle%20companion%20beside%20him%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20determined%20battle%20spirit&width=600&height=900&seq=poster-demon-slayer&orientation=portrait',
  },
  {
    id: 'one-piece',
    title: '海贼王',
    titleEn: 'One Piece',
    type: 'anime',
    categories: ['shonen', 'ri'],
    tags: ['冒险', '热血', '草帽'],
    year: 1999,
    status: 'airing',
    episodes: '连载中 1000+ 话',
    rating: 9.3,
    isHot: true,
    studio: '东映动画',
    description: '路飞立志成为海贼王，与伙伴们踏上伟大航路的冒险之旅，追寻传说中的秘宝 ONE PIECE，笑与泪交织的友情史诗。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20happy%20young%20pirate%20with%20straw%20hat%20and%20red%20vest%20grinning%20confidently%20at%20the%20sea%2C%20sailing%20ship%20behind%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20adventurous%20joy&width=600&height=900&seq=poster-one-piece&orientation=portrait',
  },
  {
    id: 'jujutsu-kaisen',
    title: '咒术回战',
    titleEn: 'Jujutsu Kaisen',
    type: 'anime',
    categories: ['shonen', 'fantasy', 'ri'],
    tags: ['咒术', '热血'],
    year: 2020,
    status: 'airing',
    episodes: '全 24 话',
    rating: 9.2,
    isHot: true,
    studio: 'MAPPA',
    description: '拥有强大咒力少年虎杖悠仁吞下特级咒物，为守护伙伴加入咒术高专，与诅咒展开生死对决，在暗黑世界中寻找意义。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20young%20male%20student%20with%20spiky%20pink%20hair%20in%20dark%20school%20uniform%20making%20a%20hand%20seal%20surrounded%20by%20shadowy%20energy%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20dark%20supernatural%20power&width=600&height=900&seq=poster-jujutsu&orientation=portrait',
  },
  {
    id: 'spy-family',
    title: '间谍过家家',
    titleEn: 'Spy x Family',
    type: 'anime',
    categories: ['comedy', 'healing', 'ri'],
    tags: ['搞笑', '家庭', '谍战'],
    year: 2022,
    status: 'airing',
    episodes: '全 25 话',
    rating: 9.0,
    isNew: true,
    studio: 'WIT STUDIO',
    description: '间谍黄昏为完成任务组建临时家庭，收养拥有读心能力的女儿阿尼亚，与职业杀手约尔组成"完美"一家人，笑料百出。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20pink%20haired%20cheerful%20little%20girl%20with%20twin%20horns%20wearing%20a%20school%20uniform%20grinning%20widely%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20playful%20family%20vibe&width=600&height=900&seq=poster-spy-family&orientation=portrait',
  },
  {
    id: 'your-name',
    title: '你的名字。',
    titleEn: 'Your Name.',
    type: 'anime',
    categories: ['romance', 'healing', 'ri'],
    tags: ['恋爱', '治愈', '电影'],
    year: 2016,
    status: 'finished',
    episodes: '全 1 话',
    rating: 9.3,
    studio: 'CoMix Wave Films',
    description: '乡村少女与都市少年在梦中互换身份，跨越时空寻找彼此，命运的红线在彗星划过的夜空下交织成最动人的物语。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20teenage%20couple%20standing%20back%20to%20back%20under%20a%20glowing%20comet%20with%20red%20thread%20binding%20their%20fingers%2C%20warm%20coral%20and%20gold%20palette%2C%20starry%20night%20background%2C%20clean%20minimal%20composition%2C%20high%20detail%20anime%20key%20visual%2C%20romantic%20dreamy%20atmosphere&width=600&height=900&seq=poster-your-name&orientation=portrait',
  },
  {
    id: 'natsume',
    title: '夏目友人帐',
    titleEn: 'Natsume\'s Book of Friends',
    type: 'anime',
    categories: ['healing', 'fantasy', 'ri'],
    tags: ['治愈', '妖怪', '温暖'],
    year: 2008,
    status: 'finished',
    episodes: '全 13 话',
    rating: 9.2,
    studio: 'Brain\'s Base',
    description: '能看见妖怪的少年夏目贵志继承祖母的友人帐，与猫咪老师一同归还妖怪的名字，在温柔与陪伴中治愈彼此的心灵。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20gentle%20young%20man%20with%20dark%20brown%20hair%20wearing%20a%20school%20uniform%20with%20a%20chubby%20white%20cat%20on%20his%20shoulder%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20gentle%20healing%20warmth&width=600&height=900&seq=poster-natsume&orientation=portrait',
  },
  {
    id: 'rezero',
    title: '从零开始的异世界生活',
    titleEn: 'Re:Zero',
    type: 'anime',
    categories: ['fantasy', 'romance', 'ri'],
    tags: ['异世界', '恋爱', '奇幻'],
    year: 2016,
    status: 'airing',
    episodes: '全 25 话',
    rating: 8.8,
    studio: 'WHITE FOX',
    description: '少年菜月昴被召唤到异世界，获得"死亡回归"的能力，在一次次的轮回中为守护重要的人而战，书写爱与绝望的物语。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20silver%20haired%20girl%20with%20blue%20eyes%20in%20a%20white%20dress%20holding%20hands%20with%20a%20young%20man%20in%20a%20tracksuit%2C%20warm%20coral%20and%20teal%20palette%2C%20magical%20island%20background%2C%20clean%20minimal%20composition%2C%20high%20detail%20anime%20key%20visual%2C%20epic%20romantic%20tone&width=600&height=900&seq=poster-rezero&orientation=portrait',
  },
  {
    id: 'chainsaw-man',
    title: '电锯人',
    titleEn: 'Chainsaw Man',
    type: 'anime',
    categories: ['shonen', 'ri'],
    tags: ['热血', '暗黑'],
    year: 2022,
    status: 'finished',
    episodes: '全 12 话',
    rating: 8.7,
    studio: 'MAPPA',
    description: '少年电次与链锯恶魔波奇塔合体成为"电锯人"，加入恶魔猎人组织，在疯狂而残酷的世界里追逐平凡而简单的梦想。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20wild%20young%20man%20with%20blond%20hair%20and%20a%20chainsaw%20emerging%20from%20his%20head%20and%20arms%2C%20warm%20coral%20and%20gold%20palette%2C%20dark%20dramatic%20background%2C%20clean%20minimal%20composition%2C%20high%20detail%20anime%20key%20visual%2C%20chaotic%20energy&width=600&height=900&seq=poster-chainsaw&orientation=portrait',
  },
  {
    id: 'ling-cage',
    title: '灵笼',
    titleEn: 'Ling Cage: Incarnation',
    type: 'anime',
    categories: ['scifi', 'guo'],
    tags: ['科幻', '国漫', '末日'],
    year: 2019,
    status: 'airing',
    episodes: '全 16 话',
    rating: 9.0,
    isHot: true,
    studio: '艺画开天',
    description: '末日废土之上，人类在巨大浮空灯塔中苟延残喘，猎荒者小队深入危险之地搜集物资，在秩序与人性之间挣扎求存。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20mecha%20pilot%20in%20a%20heavy%20armored%20suit%20standing%20before%20a%20post%20apocalyptic%20floating%20city%20with%20ruins%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20grim%20sci%20fi%20atmosphere&width=600&height=900&seq=poster-ling-cage&orientation=portrait',
  },
  {
    id: 'link-click',
    title: '时光代理人',
    titleEn: 'Link Click',
    type: 'anime',
    categories: ['fantasy', 'guo'],
    tags: ['悬疑', '奇幻', '国漫'],
    year: 2021,
    status: 'airing',
    episodes: '全 11 话',
    rating: 8.9,
    isNew: true,
    studio: '澜映画',
    description: '程小时和陆光经营着一家时光照相馆，通过照片回到过去完成委托，却在一次次改写历史中揭开隐藏的真相与代价。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20two%20young%20men%20with%20headphones%20standing%20in%20a%20vintage%20photo%20studio%20with%20projecting%20time%20lines%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20mysterious%20time%20travel%20tone&width=600&height=900&seq=poster-link-click&orientation=portrait',
  },
  {
    id: 'wu-shan-wuxing',
    title: '雾山五行',
    titleEn: 'Fog Hill of Five Elements',
    type: 'anime',
    categories: ['shonen', 'fantasy', 'guo'],
    tags: ['热血', '国漫', '武侠'],
    year: 2020,
    status: 'finished',
    episodes: '全 3 话',
    rating: 9.1,
    studio: '六道无鱼',
    description: '水墨风格的动作巨制，五行之力的守护者们在雾山深处与妖兽大战，拳拳到肉的打斗画面被奉为国漫动作天花板。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20chinese%20ink%20style%20warrior%20in%20flowing%20robes%20fighting%20a%20mythical%20beast%20amidst%20misty%20mountains%20with%20red%20seal%20stamps%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20wuxia%20action%20energy&width=600&height=900&seq=poster-wushan&orientation=portrait',
  },
  {
    id: 'fanren',
    title: '凡人修仙传',
    titleEn: 'A Record of a Mortal\'s Journey to Immortality',
    type: 'anime',
    categories: ['fantasy', 'guo'],
    tags: ['修仙', '奇幻', '国漫'],
    year: 2020,
    status: 'airing',
    episodes: '连载中 100+ 话',
    rating: 8.8,
    studio: '万维猫动画',
    description: '平凡少年韩立偶入仙途，凭借谨慎坚韧的性格在尔虞我诈的修仙界步步为营，一步步从凡人修炼成通天大能。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20chinese%20cultivation%20young%20man%20in%20flowing%20daoist%20robes%20standing%20on%20a%20floating%20sword%20over%20misty%20mountains%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20xianxia%20immortal%20tone&width=600&height=900&seq=poster-fanren&orientation=portrait',
  },
  {
    id: 'douluo',
    title: '斗罗大陆',
    titleEn: 'Soul Land',
    type: 'anime',
    categories: ['fantasy', 'guo'],
    tags: ['玄幻', '国漫'],
    year: 2018,
    status: 'airing',
    episodes: '连载中 260+ 话',
    rating: 8.5,
    studio: '玄机科技',
    description: '双生武魂少年唐三穿越至斗罗大陆，凭借蓝银草与昊天锤的双生武魂天赋，在魂师的世界里一路逆袭成为强者。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20young%20male%20soul%20master%20with%20glowing%20golden%20hammer%20and%20blue%20vines%20energy%20surrounding%20him%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20anime%20key%20visual%2C%20epic%20xuanhuan%20energy&width=600&height=900&seq=poster-douluo&orientation=portrait',
  },
  {
    id: 'oshi-no-ko',
    title: '我推的孩子',
    titleEn: 'Oshi no Ko',
    type: 'anime',
    categories: ['new', 'romance', 'ri'],
    tags: ['偶像', '恋爱', '新番'],
    year: 2023,
    status: 'airing',
    episodes: '全 11 话',
    rating: 8.9,
    isNew: true,
    studio: '动画工房',
    description: '妇产科医生与偶像粉丝转生为偶像之子，踏入娱乐圈的深渊，揭开偶像界光鲜背后的真相与复仇的序幕。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20illustration%20poster%20of%20a%20beautiful%20idol%20girl%20with%20twin%20pink%20hair%20and%20sparkling%20star%20eyes%20wearing%20a%20glittering%20stage%20outfit%2C%20warm%20coral%20and%20gold%20palette%2C%20stage%20spotlight%20background%2C%20clean%20minimal%20composition%2C%20high%20detail%20anime%20key%20visual%2C%20idol%20glamour&width=600&height=900&seq=poster-oshinoko&orientation=portrait',
  },
];

export const mangaWorks: Work[] = [
  {
    id: 'm-berk',
    title: '剑风传奇',
    titleEn: 'Berserk',
    type: 'manga',
    categories: ['m-youth', 'fantasy'],
    tags: ['青年漫', '奇幻', '史诗'],
    year: 1989,
    status: 'airing',
    episodes: '连载中 380+ 话',
    rating: 9.7,
    isHot: true,
    studio: '白泉社',
    description: '雇佣剑士格斯在黑暗的中世纪世界挣扎求生，与宿命的对手格里菲斯纠缠对抗，被誉为黑暗奇幻漫画的巅峰之作。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20massive%20muscular%20swordsman%20carrying%20a%20giant%20dragon%20slayer%20sword%20on%20his%20back%2C%20dark%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20grim%20dark%20fantasy%20tone&width=600&height=900&seq=poster-m-berk&orientation=portrait',
  },
  {
    id: 'm-slam-dunk',
    title: '灌篮高手',
    titleEn: 'Slam Dunk',
    type: 'manga',
    categories: ['m-boy', 'm-hot'],
    tags: ['少年漫', '篮球', '热血'],
    year: 1990,
    status: 'finished',
    episodes: '全 276 话',
    rating: 9.6,
    studio: '集英社',
    description: '问题少年樱木花道为追女神加入湘北篮球队，从门外汉成长为篮板高手，与队友们向着全国大赛的梦想全力冲刺。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20red%20haired%20basketball%20player%20dunking%20a%20ball%20high%20in%20the%20air%20with%20energy%20and%20speed%20lines%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20sports%20passion&width=600&height=900&seq=poster-m-slamdunk&orientation=portrait',
  },
  {
    id: 'm-one-piece',
    title: '海贼王 漫画',
    titleEn: 'One Piece Manga',
    type: 'manga',
    categories: ['m-boy', 'm-hot'],
    tags: ['少年漫', '热血', '冒险'],
    year: 1997,
    status: 'airing',
    episodes: '连载中 1100+ 话',
    rating: 9.4,
    isHot: true,
    studio: '集英社',
    description: '少年路飞的冒险漫画原作，承载着无数读者的青春回忆，是少年热血漫的不朽传奇。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20grinning%20pirate%20boy%20with%20straw%20hat%20holding%20a%20treasure%20map%20with%20sailing%20ship%20in%20wavy%20sea%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20adventurous%20spirit&width=600&height=900&seq=poster-m-onepiece&orientation=portrait',
  },
  {
    id: 'm-haikyu',
    title: '排球少年',
    titleEn: 'Haikyuu!!',
    type: 'manga',
    categories: ['m-boy', 'm-hot'],
    tags: ['少年漫', '排球', '热血'],
    year: 2012,
    status: 'finished',
    episodes: '全 402 话',
    rating: 9.5,
    studio: '集英社',
    description: '个子矮小的日向翔阳与天才二传手影山飞雄组建搭档，在乌野高中排球队向全国大赛发起冲击，燃到极致的热血竞技。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20two%20high%20school%20volleyball%20players%20leaping%20for%20a%20spike%20at%20the%20net%20with%20a%20crow%20mascot%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20energetic%20sports%20competition&width=600&height=900&seq=poster-m-haikyu&orientation=portrait',
  },
  {
    id: 'm-conan',
    title: '名侦探柯南',
    titleEn: 'Detective Conan',
    type: 'manga',
    categories: ['m-boy'],
    tags: ['少年漫', '推理'],
    year: 1994,
    status: 'airing',
    episodes: '连载中 1100+ 话',
    rating: 9.1,
    studio: '小学馆',
    description: '高中生侦探工藤新一被黑暗组织灌下毒药变小，以江户川柯南的身份继续破案，追寻组织的真相。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20detective%20boy%20with%20glasses%20and%20bow%20tie%20in%20a%20blue%20jacket%20holding%20a%20magnifying%20glass%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20mysterious%20detective%20tone&width=600&height=900&seq=poster-m-conan&orientation=portrait',
  },
  {
    id: 'm-blue-lock',
    title: '蓝色监狱',
    titleEn: 'Blue Lock',
    type: 'manga',
    categories: ['m-boy', 'm-hot'],
    tags: ['少年漫', '足球', '热血'],
    year: 2018,
    status: 'airing',
    episodes: '连载中 300+ 话',
    rating: 9.0,
    isNew: true,
    studio: '讲谈社',
    description: '为了培养世界最强前锋，300名高中锋线球员被关入"蓝色监狱"，在残酷的淘汰制中磨炼出利己主义的极致射门技术。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20determined%20young%20football%20forward%20kicking%20a%20soccer%20ball%20inside%20a%20dark%20blue%20prison%20facility%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20intense%20sports%20rivalry&width=600&height=900&seq=poster-m-bluelock&orientation=portrait',
  },
  {
    id: 'm-frieren',
    title: '葬送的芙莉莲 漫画',
    titleEn: 'Frieren Manga',
    type: 'manga',
    categories: ['m-boy', 'fantasy'],
    tags: ['少年漫', '奇幻', '治愈'],
    year: 2020,
    status: 'airing',
    episodes: '连载中 130+ 话',
    rating: 9.5,
    isNew: true,
    studio: '小学馆',
    description: '精灵魔法使芙莉莲在漫长岁月中重新理解人类的情感，原作漫画细腻动人的笔触与温暖深刻的哲思广受好评。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20gentle%20elf%20mage%20with%20silver%20hair%20reading%20an%20old%20spellbook%20under%20a%20warm%20glowing%20tree%2C%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20tender%20contemplative%20tone&width=600&height=900&seq=poster-m-frieren&orientation=portrait',
  },
  {
    id: 'm-spy',
    title: '间谍过家家 漫画',
    titleEn: 'Spy x Family Manga',
    type: 'manga',
    categories: ['m-boy', 'm-comedy'],
    tags: ['搞笑漫画', '家庭'],
    year: 2019,
    status: 'airing',
    episodes: '连载中 100+ 话',
    rating: 9.2,
    studio: '集英社',
    description: '间谍、杀手、超能力者组成的"假"家庭笑料百出，原作漫画以轻松诙谐的笔触讲述温暖搞笑的家庭故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20happy%20pink%20haired%20little%20girl%20with%20twin%20horns%20surrounded%20by%20her%20parents%20smiling%20in%20a%20cozy%20living%20room%2C%20warm%20coral%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20warm%20family%20comedy&width=600&height=900&seq=poster-m-spy&orientation=portrait',
  },
  {
    id: 'm-demon',
    title: '鬼灭之刃 漫画',
    titleEn: 'Demon Slayer Manga',
    type: 'manga',
    categories: ['m-boy', 'm-hot'],
    tags: ['少年漫', '热血'],
    year: 2016,
    status: 'finished',
    episodes: '全 205 话',
    rating: 9.3,
    studio: '集英社',
    description: '炭治郎与鬼舞辻无惨的最终对决，原作漫画以华丽的剑技与深刻的情感共鸣成为现象级热血大作。',
    cover:
      'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20swordsman%20with%20checkered%20haori%20swinging%20a%20glowing%20water%20technique%20blade%2C%20warm%20coral%20and%20teal%20palette%2C%20clean%20minimal%20background%2C%20high%20detail%20manga%20key%20visual%2C%20dynamic%20sword%20combat&width=600&height=900&seq=poster-m-demon&orientation=portrait',
  },
];

export const allWorks: Work[] = [...animeWorks, ...mangaWorks];

// 通过作品 id 查找作品
export function findWorkById(id: string): Work | undefined {
  return allWorks.find((w) => w.id === id);
}

// 通过分类 id 筛选作品
export function filterWorksByCategory(categoryId: string): Work[] {
  if (!categoryId || categoryId === 'all') return allWorks;
  return allWorks.filter((w) => w.categories.includes(categoryId));
}

// 新番（按 isNew 或包含 new 分类）
export function getNewSeasonWorks(): Work[] {
  return allWorks.filter((w) => w.isNew || w.categories.includes('new'));
}

// 热门作品（按 isHot 排序，再按评分）
export function getHotWorks(): Work[] {
  return [...allWorks].sort((a, b) => Number(b.isHot) - Number(a.isHot) || b.rating - a.rating);
}